var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32531 3.27112C6.32531 1.72098 7.33062 0.464355 8.57072 0.464355H15.3069C16.5471 0.464355 17.5524 1.72098 17.5524 3.27112V6.07788H19.7862H19.8071H22.0432C22.6632 6.07788 23.1659 6.7062 23.1659 7.48126C23.1659 8.25632 22.6632 8.88464 22.0432 8.88464H20.8431L19.8694 25.9252C19.7854 27.394 18.8078 28.532 17.6297 28.532H6.24798C5.06995 28.532 4.09221 27.394 4.00828 25.9252L3.03453 8.88464H1.8345C1.21445 8.88464 0.711792 8.25632 0.711792 7.48126C0.711792 6.7062 1.21445 6.07788 1.8345 6.07788H4.07063H4.09149H6.32531V3.27112ZM8.57071 6.07774H15.3069V3.27098H8.57071V6.07774ZM6.24805 25.7251L5.28573 8.88451H18.592L17.6298 25.7251H6.24805ZM9.69342 11.6914C10.3135 11.6914 10.8161 12.3197 10.8161 13.0948V21.5151C10.8161 22.2902 10.3135 22.9184 9.69342 22.9184C9.07337 22.9184 8.57071 22.2902 8.57071 21.5151V13.0948C8.57071 12.3197 9.07337 11.6914 9.69342 11.6914ZM15.3069 13.0948C15.3069 12.3197 14.8043 11.6914 14.1842 11.6914C13.5641 11.6914 13.0615 12.3197 13.0615 13.0948V21.5151C13.0615 22.2902 13.5641 22.9184 14.1842 22.9184C14.8043 22.9184 15.3069 22.2902 15.3069 21.5151V13.0948Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.8d4f0d6df6e3bd5f142d72dc5aed1c82.svg";
export { ForwardRef as ReactComponent };